module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-dialog', {
    attrs: {
      "padding": '2em 3em',
      "max-width": '900px',
      "height": '80%'
    }
  }, [_c('div', {
    staticClass: "mv3 center-xs trial-teacher-title b"
  }, [_vm._v("\n      Include Free Trial Teachers\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "trial-teacher-sub-title"
  }, [_vm._v("\n      This is a list of teachers whose accounts are not upgraded, but whose\n      email addresses also match the approved email suffixes for your school /\n      district. Check any teachers whose data you’d like to include in your\n      data analytics results. Parlay will automatically save your selection\n      for next time.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row mv3"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(!_vm.loading) ? _c('pl-input', {
    attrs: {
      "placeholder": "Search by name"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filters.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.user_search),
      callback: function($$v) {
        _vm.user_search = $$v
      },
      expression: "user_search"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(!_vm.loading) ? _c('pl-input', {
    attrs: {
      "placeholder": "Search by email"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filters.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.email_search),
      callback: function($$v) {
        _vm.email_search = $$v
      },
      expression: "email_search"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mv3"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row modal-body mt5 center-xs"
  }, [_c('pl-spinner', {
    staticClass: "x2"
  })], 1) : (!_vm.loading && !_vm.trialTeachers.length) ? _c('div', {
    staticClass: "modal-body pt5 center-xs b"
  }, [_vm._v("\n        No users.\n      ")]) : (!_vm.loading && _vm.trialTeachers.length) ? _c('table', {
    staticClass: "w-100"
  }, [_c('thead', [_c('tr', {
    staticClass: "row no-margin"
  }, [_c('td', {
    staticClass: "col-xs-1 b"
  }), _vm._v(" "), _c('td', {
    staticClass: "col-xs-3 b"
  }, [_vm._v("Name")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-4 b"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 b"
  }, [_vm._v("Role")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 b"
  }, [_vm._v("Last Active")])])]), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "trial_teachers-table"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l((_vm.trialTeachers), function(user, index) {
    return _c('tr', {
      staticClass: "row no-margin middle-xs"
    }, [_c('td', {
      staticClass: "col-xs-1"
    }, [_c('pl-checkbox', {
      attrs: {
        "value": user.id
      },
      model: {
        value: (_vm.selectedTrialTeachers),
        callback: function($$v) {
          _vm.selectedTrialTeachers = $$v
        },
        expression: "selectedTrialTeachers"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "col-xs-3 middle-xs flex",
      staticStyle: {
        "padding-left": "0"
      }
    }, [_c('div', {
      staticClass: "avatar-circle avatar-size mr2",
      style: ({
        backgroundImage: 'url(' + user.avatar_url + ')',
        'background-size': 'cover',
        'background-position': 'center',
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "truncate-text",
      attrs: {
        "title": user.name
      }
    }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4 truncate-text",
      attrs: {
        "title": user.email
      }
    }, [_vm._v("\n              " + _vm._s(user.email) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 user-role"
    }, [_vm._v("\n              " + _vm._s(user.role) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 center-xs"
    }, [_vm._v(_vm._s(user.last_active))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row w-100 center-xs",
    staticStyle: {
      "height": "30px"
    }
  }, [(_vm.loading_table_body) ? _c('div', [_c('pl-spinner', {
    staticClass: "x5"
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-center"
  }, [_c('pl-button', {
    staticClass: "pl-white",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        CANCEL\n      ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "f3 pl-primary b truncate-text",
    attrs: {
      "disabled": !_vm.has_changes
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        SAVE AND CLOSE\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4835b2ee!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/analytics/trialTeachersModal.vue
// module id = 2137
// module chunks = 61